import React, {useEffect, useState} from "react";
import {BreadCrumbItem} from "../../organisms/HeaderSection";
import Page from "../../organisms/Page";
import TableSection from "./TableSection";
import {ItemListadoServiciosGuarderia, listarServiciosGuarderia} from "../../../services/guarderiaServicios";

const breadCrumbs: BreadCrumbItem[] = [
    {
        path: "/",
        label: "Inicio"
    },
    {
        path: "/servicios",
        label: "Servicios"
    },
    {
        path: "/sevicios/guarderia",
        label: "Guardería",
        isActive: true
    }
]

function ListaServiciosGuarderia(){
    const [items, setItems] = useState([] as ItemListadoServiciosGuarderia[]);

    useEffect(() => {
        async function poblarItems() {
            const resp = await listarServiciosGuarderia();
            if(resp){
                setItems(resp);
            }
        }

        poblarItems();
    }, []);

    return (
        <Page description="Visualiza, edita y crea servicios de guardería." title="Reservas de Guardería" breadCrumbs={breadCrumbs}>
            <TableSection items={items} />
        </Page>
    );
}

export default ListaServiciosGuarderia;